<template>
  <q-page padding>
    <base-form :resource="$route.meta.resource" :id="this.$route.params.id" :readonly="readonly">
      <!-- <div slot="name__field" slot-scope="props" v-if="$route.params.id"> -->
      <div slot="bottom" v-if="$route.params.id">
        <company-persons></company-persons>
      </div>
    </base-form>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyPersons from '../../../components/fields/CompanyPersons'

export default {
  name: 'EditForm',
  components: { CompanyPersons },
  computed: {
    ...mapGetters('auth', ['user', 'roles', 'hasRole']),
    readonly () {
      if (this.hasRole('Super Admin') || this.hasRole('Super Admin') || this.hasRole('Super Admin')) {
        return false
      }
      return true
    }
  }
}
</script>

<style>
</style>
